import api from './api'
import { Subject } from 'rxjs'
import { take, distinctUntilChanged } from 'rxjs/operators'

interface Message {
    f: string
    to: string
    t: number
    m: string
    mm?: any[]
}

export default new (class {
    public messages: Subject<Message> = new Subject()
    constructor() {
        api.socket.on(
            'messages created',
            this.messages.next.bind(this.messages)
        )
    }
    loadMessages(skip = 0, mode = 'append') {
        const subject: Subject<Message> = new Subject()
        setTimeout(async () => {
            const messageResponse = await api.service('messages').find({
                query: {
                    $skip: skip,
                    $limit: 50,
                    $sort: {
                        t: -1,
                    },
                },
            })
            const messages: any[] = messageResponse.data
            if (mode === 'append') {
                messages.reverse()
            }
            messages.forEach((m: any) => subject.next(m))
        }, 0)
        return subject
    }
    async sendMessage(message = '', multimedia?: any[]) {
        const user = await api.user.pipe(take(1)).toPromise()
        const msg: Message = {
            f: user._id,
            to: user.partner,
            t: new Date().getTime(),
            m: message,
        }
        if (multimedia) {
            msg.mm = multimedia
        }
        const result = await api.service('messages').create(msg)
        console.log(result)
    }
})()
